import React from 'react';
import { useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import EditIcon from '@material-ui/icons/Edit';
import FileCopyIcon from '@material-ui/icons/FileCopy';
import { NAME_SPACE } from 'i18n';
import { PATH } from 'app.routes.const';
import { ViewTable, execConfirmModal, ButtonAdd, ButtonDelete } from 'shared';
import { useListStickersStyles } from './listStickers.styles';
import { useStickersPaginated } from './useStickersPaginated';
import { useStickersBuildTable } from './useStickersBuildTable';

export function ListStickers() {
  const classes = useListStickersStyles();
  const { stickers, getStickers, deleteStickers, copySticker, errorInfo } = useStickersPaginated();
  const { t } = useTranslation(NAME_SPACE.STICKERS);
  const history = useHistory();

  const { rows, headCells } = useStickersBuildTable(stickers, t);

  function handleEdit([stickerId]) {
    history.push(PATH.STICKERS.EDIT.replace(':id', stickerId));
  }

  function handleAdd() {
    history.push(PATH.STICKERS.CREATE);
  }

  async function handleDelete(stickersToDelete) {
    try {
      await execConfirmModal({
        title: t('common:actions.remove'),
        description:
          stickersToDelete.length > 1
            ? t('removeConfirm.message', { length: stickersToDelete.length })
            : t('removeConfirm.singularMessage', {
                name: stickersToDelete[0].name
              }),
        confirmText: t('common:actions.accept'),
        declineText: t('common:actions.cancel'),
        confirmClassName: classes.buttonAdd,
        declineClassName: classes.buttonDelete
      });
      await deleteStickers(stickersToDelete);
    } catch (err) {}
  }

  async function handleCopy([stickerId]) {
    await copySticker(stickerId);
  }

  return (
    <div className={classes.stickers}>
      <ViewTable
        elevation
        spaced
        errors={errorInfo}
        rows={rows}
        cells={headCells}
        defaultOrderBy={{ property: 'name', direction: 'asc' }}
        mainKey={'name'}
        onFetchData={getStickers}
        totalRows={stickers.total}
        serverSidePaging
        emptyText={t('empty')}
        actions={[
          {
            title: t('actions.edit'),
            name: 'edit',
            properties: ['id'],
            label: 'edit this row',
            cb: handleEdit,
            icon: <EditIcon />
          },
          {
            title: t('actions.copy'),
            name: 'copy',
            properties: ['id'],
            label: 'copy this row',
            cb: handleCopy,
            icon: <FileCopyIcon />
          }
        ]}
        toolbar={{
          title: t('name'),
          actions: [
            {
              condition: isAnySelected => !isAnySelected,
              cb: handleAdd,
              component: ButtonAdd
            },
            {
              condition: isAnySelected => isAnySelected,
              resetOnCB: true,
              cb: handleDelete,
              component: ButtonDelete
            }
          ]
        }}
      />
    </div>
  );
}
